import { Box, BoxProps, Theme, styled } from '@mui/material';
import { ColorOptions } from '@synergy/theme-next';
import { ReactElement } from 'react';

export const Progressbar = styled(Box, { shouldForwardProp: prop => prop !== 'color' })<{
    color?: ColorOptions | undefined;
}>(({ theme, color }: { theme: Theme; color?: ColorOptions }) => ({
    height: theme.spacing(0.5),
    borderRadius: theme.spacing(0.5),
    backgroundColor: theme.palette.grey[300],

    ...(color &&
        color !== 'inherit' && {
            backgroundColor: theme.palette[color].main,
        }),
}));

export interface ProgressBarProps extends BoxProps {
    currentSum: number;
    limit: number;
}

export const PoolProgressBar = (props: ProgressBarProps): ReactElement => {
    const { currentSum, limit, ...boxProps } = props;

    const getProgress = (): number => {
        const progress = (((currentSum * 100) / limit) * 280) / 100;
        return currentSum < limit ? progress : 280;
    };

    const getColor = (): ColorOptions => {
        return getProgress() >= 280 ? 'primary' : 'dark';
    };

    return (
        <Progressbar {...boxProps} color={undefined}>
            <Progressbar color={getColor()} sx={{ width: getProgress() }} />
        </Progressbar>
    );
};
